"use strict";
var unitas = unitas || {};
const siteNav = document.querySelector("#js-site-navigation");
const siteHeader = document.querySelector("#js-site-header");
const myUnitasTrigger = document.getElementById(
  "js-site-header-my-unitas-dropdown-trigger"
);
const myUnitasDropdown = document.getElementById(
  "js-site-header-my-unitas-dropdown"
);
const navItemsHasChildren = document.querySelectorAll(
  ".menu-item-has-children:not(.pll-parent-menu-item) > a"
);
const siteHeaderActionsMobile = document.getElementById(
  "js-site-header-actions-mobile"
);
const siteNavInner = document.getElementById("js-site-nav-inner");
const siteHeaderInner = document.getElementById("js-site-header-inner");
const myUnitasMobileDropdownTrigger = document.getElementById(
  "js-site-header-mobile-my-unitas-dropdown-trigger"
);
const myUnitasMobileDropdown = document.getElementById(
  "js-site-header-mobile-my-unitas-dropdown"
);
const polylangTrigger = document.getElementsByClassName(
  "pll-parent-menu-item"
)[0];
const siteHeaderActions = document.getElementById("js-site-header-actions");

unitas.sitenavigation =
  unitas.sitenavigation ||
  (function() {
    function init() {
      if (polylangTrigger) {
        siteHeaderInner.appendChild(polylangTrigger);

        polylangTrigger.addEventListener("click", function() {
          const langSubmenu = polylangTrigger.getElementsByClassName(
            "sub-menu"
          )[0];
          langSubmenu.classList.toggle("sub-menu--open");
        });
      }

      if (siteNav && window.innerWidth > 992) {
        if (navItemsHasChildren.length > 0) {
          for (let i = 0; i < navItemsHasChildren.length; i++) {
            const current = navItemsHasChildren[i];

            current.addEventListener("click", function(e) {
              // e.preventDefault();

              closeAll();

              // current.parentNode.classList.add("menu-item--open");
              // siteHeader.classList.add("site-header--open");
            });
          }
        }
      } else {
        if (siteHeaderActionsMobile && siteNavInner) {
          siteNavInner.appendChild(siteHeaderActionsMobile);
          siteHeaderActionsMobile.appendChild(polylangTrigger);
          // siteHeaderActionsMobile.classList.add('site-header-actions-mobile--visible');
          siteHeaderActionsMobile.style.display = "block";
        }
      }

      if (myUnitasDropdown && myUnitasTrigger) {
        setupMyUnitasDropdown();
      }

      if (myUnitasMobileDropdown && myUnitasMobileDropdownTrigger) {
        setupMyUnitasMobileDropdown();
      }

      // setupCurrentMenuItemsForTaxonomyPages();
    }

    function setupCurrentMenuItemsForTaxonomyPages() {
      const bodyClassList = document.body.classList;
      // console.log(bodyClassList);
      // console.log(bodyClassList.indexOf('js-travel-type-skole-og-studierejser', 0));

    }

    function hasClass(element, className) {
      return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
    }

    function setupMyUnitasDropdown() {
      myUnitasTrigger.addEventListener("click", function(e) {
        e.preventDefault;
        myUnitasDropdown.classList.toggle(
          "site-header-actions-my-unitas-dropdown--open"
        );
      });
    }

    function setupMyUnitasMobileDropdown() {
      myUnitasMobileDropdownTrigger.addEventListener("click", function(e) {
        e.preventDefault;
        myUnitasMobileDropdown.classList.toggle(
          "site-header-actions-mobile-my-unitas-dropdown--open"
        );
      });
    }

    function closeAll() {
      for (let i = 0; i < navItemsHasChildren.length; i++) {
        const current = navItemsHasChildren[i];
        current.parentNode.classList.remove("menu-item--open");
        current.parentNode.classList.remove("current-menu-ancestor");
      }
    }
    return {
      init: init,
    };
  })();
